




























































































































































import {
    Component,
    Mixins,
    Watch
} from 'vue-property-decorator';
import PaginationComponentMixin from '@/mixins/PaginationComponent';
import TaxonomyMixin from '@/mixins/TaxonomyComponent';
import MultiSelectRow from '@/mixins/MultiSelectRow';
import DateRangeForReport from '@/components/DateRangeForReports.vue';
import UserLazydropdown from '@/components/lazyDropdown/UserLazydropdown.vue';
import DepartmentLazydropdown from '@/components/lazyDropdown/DepartmentLazydropdown.vue';
import CreditDetails from '@/views/shortCredit/creditDetails.vue';
import FilterDrawerComponent from "@/components/FilterDrawerComponent.vue";
import {
    QueryBuilder
} from '@/classes/QueryBuilder';
import {
    Permission as PermissionEnum
} from '@/enums/Permission';
import moment from 'moment';

@Component({
    components: {
        DateRangeForReport,
        UserLazydropdown,
        DepartmentLazydropdown,
        CreditDetails,
        FilterDrawerComponent
    }
})
export default class ShortCreditList extends Mixins(PaginationComponentMixin, TaxonomyMixin, MultiSelectRow) {
    public selectedButton: string = 'Today';
    public entities: any = [];
    public currentEntity: any = {};
    public loading: boolean = false;
    public statusLoading: boolean = false;
    public isShowMethod: boolean = false;
    public dialogVisible: boolean = false;
    public multipleSelection: any = '';
    private queryBuilder = new QueryBuilder();
    public selectedDateRange: string = moment().format('YYYY-MM-DD') + ',' + moment().format('YYYY-MM-DD');
    public creditSetting: any = {};
    public isFilterModelActive: boolean = false;
    public downloading: boolean = false;
    get permissionEnum() {
        return PermissionEnum;
    }
    public bulkForm = {
        comment: ''
    };
    public filters: any = {
        status: this.$route.name === 'requested' ? 'pending,accepted' : 'approved',
        range: '',
        departmentId: '',
        created_by: '',
        defaulter: '',
        defaulter_days: ''
    };

    public statuses: any = [{
            title: 'Pending',
            value: 'pending'
        },
        {
            title: 'Accepted',
            value: 'accepted'
        },
        {
            title: 'Approved',
            value: 'approved'
        },
        {
            title: 'Rejected',
            value: 'rejected'
        },
        {
            title: 'Cancelled',
            value: 'cancelled'
        },
        {
            title: 'Closed',
            value: 'closed'
        }
    ];

    created() {
        this.fetchCreditSetting();
        this.queryBuilder.addListener('range', this.selectedDateRange);
    }

    getPageTitle() {
        const string = this.$route.name || this.getTaxonomy('department') + ' Credits';
        return string.charAt(0).toUpperCase() + string.slice(1) + ' Credits';
    }

    capitalize(string: string) {
        if (typeof string !== 'string') return '';
        return string.charAt(0).toUpperCase() + string.slice(1);
    }

    getCreditPeriod(created_at: string, payment_date: string) {
        const startDate = moment(created_at).startOf('day');
        const endDate = moment(payment_date).startOf('day');
        return endDate.diff(startDate, 'days');
    }

    fetchCreditSetting() {
        this.$http.get(this.$api('/credit-setting'))
            .then(response => {
                this.creditSetting = response.data.creditSetting;
            })
            .catch(error => {
                this.$notify({
                    title: 'Something went wrong.',
                    message: 'Unable to fetch credit setting.',
                    type: "error"
                })
            });
    }

    @Watch('filters.range', {
        deep: true
    })
    onChangeSubmissionDateRange(value: string) {
        if (value) {
            this.selectedButton = "";
            this.queryBuilder.addListener('range', value);
        } else {
            this.selectedButton = 'Today';
            this.queryBuilder.addListener('range', moment().format('YYYY-MM-DD') + ',' + moment().format('YYYY-MM-DD'));
        }
    }

    @Watch('filters.created_by', {
        deep: true
    })
    onChangeCreator(value: number) {
        this.queryBuilder.addListener('created_by', value);
    }
    @Watch('filters.departmentId', {
        deep: true
    })
    onChangeBuyer(value: number) {
        this.queryBuilder.addListener('department_id', value);
    }

    @Watch('filters.status', {
        deep: true
    })
    onChangeStatus(value: string) {
        this.queryBuilder.addListener('status', value);
    }
    @Watch('filters.defaulter', {
        deep: true
    })
    onChangeDefaulter(value: string) {
        this.queryBuilder.addListener('defaulter', value);
    }
    @Watch('filters.defaulter_days', {
        deep: true
    })
    onChangeDefaulterDay(value: string) {
        this.queryBuilder.addListener('defaulter_days', value);
    }

    @Watch('$route.name')
    onRouteChangeFetchEntity() {
        this.entities = [];
        this.fetchEntity();
    }

    @Watch('pagination.currentPage')
    @Watch('queryBuilder.watch')
    async fetchEntity() {
        this.loading = true;
        let url = `/department-credits${this.queryBuilder.getFilters(true) ? this.queryBuilder.getFilters(true) : '?'}&page=${this.pagination.currentPage}&from=${this.$route.name}`;
        if (!url.includes('&status=')) {
            url += `&status=${this.$route.name === 'requested' ? 'pending,accepted' : 'approved'}`;
        }
        let {
            data
        } = await this.$http.get(this.$api(url));
        this.entities = data.credits;
        this.setPagination(data);
        this.loading = false;
    }

    submitBulkAction(status: string) {
        this.statusLoading = true;
        this.$http.post(this.$api3(`/payment-status-update`),
                this.allItemSelected ? {
                    payment_ids: [],
                    status: status,
                    comment: this.bulkForm.comment
                } : {
                    payment_ids: this.selectedRows.map(payment => payment.id),
                    status: status,
                    comment: this.bulkForm.comment
                }
            )
            .then(response => {
                this.$notify({
                    title: 'Successful!',
                    message: 'Status update successfully.'
                })
                this.selectedRows = [];
                this.bulkForm.comment = '';
                this.pagination.currentPage = 1;
                this.fetchEntity();
            })
            .catch(error => {
                this.$notify({
                    title: 'Something went wrong.',
                    message: 'Unable to update status.',
                    type: "error"
                })
            })
            .finally(() => {
                this.statusLoading = false;
                this.dialogVisible = false;
            });
    }

    updateDateRange(range: string) {
        this.selectedButton = range;
        if (range === 'Today') {
            this.selectedDateRange = moment().format('YYYY-MM-DD') + ',' + moment().format('YYYY-MM-DD');
        } else if (range === 'MTD') {
            this.selectedDateRange =
                moment()
                .startOf('month')
                .format('YYYY-MM-DD') +
                ',' +
                moment().format('YYYY-MM-DD');
        } else if (range === 'LMONTH') {
            this.selectedDateRange =
                moment() 
                .subtract(1, 'month').startOf('month') 
                .format('YYYY-MM-DD') +
                ',' +
                moment().subtract(1, 'month').endOf('month').format('YYYY-MM-DD');
        }
        this.queryBuilder.addListener('range', this.selectedDateRange);
    }

    resetBtn() {
        this.filters = {
            status: this.$route.name === 'requested' ? 'pending,accepted' : 'approved',
            range: '',
            departmentId: '',
            created_by: '',
            defaulter: '',
            defaulter_days: ''
        };
    }

    showDetails(row: any) {
        if (this.$route.name === 'requested' && row.current_status === 'pending') {
            row.approved_amount = row.request_amount;
        }
        this.currentEntity = row;
        this.isShowMethod = true;
    }

    updateedAction() {
        this.fetchEntity();
    }

    async onClickDownload() {
        this.downloading = true;

        let creditIds = this.selectedRows.map((row: any) => row._id);
        if (this.allItemSelected) {
            creditIds = [];
        }
        let url = this.$api('/short-credit-download?' + this.queryBuilder.getFilters());
        if (!url.includes('&status=')) {
            url += `&status=${this.$route.name === 'requested' ? 'pending,accepted' : 'approved'}`;
        }
        if (creditIds.length > 0) {
            url += '&creditIds=' + creditIds.join(',');
        }

        try {
            let {
                data,
                headers
            } = await this.$http.get(url, {
                responseType: 'arraybuffer'
            });
            const blob = await new Blob([data], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            });
            const link = document.createElement("a");
            link.href = await URL.createObjectURL(blob);
            link.download = this.$getFileNameFromContentDisposition(headers);
            link.click();
        } catch (e) {
            this.$notify({
                title: 'Something wants wrong!',
                type: 'warning',
                message: 'Unable to download reports.',
            })
        } finally {
            this.downloading = false;
        }
    }
}
